import ApiHttp from '../http';
import FeaturedContent from '../model/FeaturedContent';
import MovieService from './movie-service'
import PageService from './page-service'


const TABBEDPAGETYPES = {
    "About Ster-Kinekor": "about-ster-kinekor",
}

const PREVIEW_SETTINGS = {
    promotion: {
        primary_route: "/exclusive-to-sk/promotions",
        availableroutes: [
            {name: "Promotion Listing", route: "/exclusive-to-sk/promotions"},
            {name: "Promotion Detail", route: "/promotion/:nid"},
            {
                name: "Home Page",
                route: "/",
                test: (promo)=>(promo.related_movie !== undefined || promo.next_to_movie !== undefined)
            },
            {
                name: "Related Movie",
                route: "/details/:related_movie",
                test: (promo)=>(promo.related_movie !== undefined || promo.next_to_movie !== undefined)
            },
        ],
        formatter: '_formatPromoOrEvent',
    },
    featured_content: {
        primary_route: "/",
        availableroutes: [
            {name: "Home Page", route: "/",},
        ],
        formatter: '_formatFeaturedContent',
        formatterIsPromise: true
    },
    competition: {
        primary_route: "/competitions",
        availableroutes: [
            {name: "Competitions", route: "/competitions",},
            {name: "Competition Detail", route: "/competition/:nid",},
        ],
        formatter: '_formatCompetition'
    },
    event: {
        primary_route: "/exclusive-to-sk/events",
        availableroutes: [
            {name: "Event Listing", route: "/exclusive-to-sk/events"},
            {name: "Event Detail", route: "/event/:nid"},
            {
                name: "Related Movie",
                route: "/details/:related_movie",
                test: (promo)=>(promo.related_movie !== undefined || promo.next_to_movie !== undefined)
            },
        ],
        formatter: '_formatPromoOrEvent',
    },
    general_page: {
        primary_route: "/content:route",
        availableroutes: [
            {
                name: "Tabbed View",
                route: "/content/:tabbedPage:route",
                routeReplace: (previewContent, route)=>route.replace(new RegExp(`:tabbedPage`, 'g'), TABBEDPAGETYPES[previewContent.page_type]),
                test: (previewContent)=>TABBEDPAGETYPES[previewContent.page_type] !== undefined
            },
            {
                name: "Static View",
                route: "/content:route",
            },
        ],
        formatter: '_formatGeneralPage',
    },
    accolades: {
        primary_route: "/content/preview-:nid",
        availableroutes: [
            {name: "Accolade Only", route: "/content/preview-:nid",},
            {name: "In Vision Mission (if Published)", route: "/content/vision-mission/our-success",},
        ],
        formatter: '_formatContentTypeForGeneralPage',
        formatterIsPromise: true
    },
    partners: {
        primary_route: "/content/preview-:nid",
        availableroutes: [
            {name: "Partners Only", route: "/content/preview-:nid",},
            {name: "In About (if Published)", route: "/content/vision-mission/our-partners",},
        ],
        formatter: '_formatContentTypeForGeneralPage',
        formatterIsPromise: true
    },
    person: {
        primary_route: "/content/preview-:nid",
        availableroutes: [
            {name: "Persons Only", route: "/content/preview-:nid",},
            {
                name: "In About (if Published)", route: "/content/vision-mission/:t",
                routeReplace: (previewContent, route)=>route.replace(new RegExp(`:t`, 'g'), previewContent.original_item.person_type == 'Management_Team' ? 'management-team' : 'shareholders'),
            },
        ],
        formatter: '_formatContentTypeForGeneralPage',
        formatterIsPromise: true
    },
    news: {
        primary_route: "/news",
        availableroutes: [
            {name: "News Listing", route: "/news",},
            {name: "News Detail", route: "/news/detail/:nid",},
        ],
        formatter:'_formatNews'

    },
}

class PreviewService {

    constructor() {
        this._previewContent = sessionStorage.getItem("_previewContent") ? JSON.parse(sessionStorage.getItem("_previewContent")) : {};
        this.available = true;
        this.cms_url = sessionStorage.getItem("cms_url") || undefined;
        this._previewSection = sessionStorage.getItem("_previewSection") || undefined;
        this.promise = undefined;
    }

    hasPreviewContent(section = this._previewSection) {
        return this._previewSection === section && this._previewContent && Object.keys(this._previewContent).length > 0;
    }

    hasPreviewContentForRelatedMovie(section = this._previewSection, movieID) {
        return this._previewSection === section && this._previewContent && Object.keys(this._previewContent).length > 0
            && (this._previewContent.related_movie && this._previewContent.related_movie === movieID ||
            this._previewContent.next_to_movie && this._previewContent.next_to_movie === movieID);
    }

    getPreviewContent(section = this._previewSection) {
        return this.hasPreviewContent(section) ? this._previewContent : {};
    }

    _formatPromoOrEvent(item) {
        return {
            nid: item.nid || undefined,
            big_title: item.big_title || undefined,
            title: item.title || undefined,
            strapline: item.strapline || undefined,
            detail: item.detail || undefined,
            related_movie: item.related_movie ? item.related_movie.vista_movie_id : undefined,
            next_to_movie: item.promo_poster_placement_mov ? item.promo_poster_placement_mov.vista_movie_id : undefined,
            button_link: item.button_link || undefined,
            button_text: item.button_text || undefined,
            button_2_link: item.button_2_link || item.additional_button_link || undefined,
            button_2_text: item.button_2_text || item.additional_button_text || undefined,
            questions: item.questions || undefined,
            images: {
                desktop: item.image_desktop || {},
                mobile: !(item.image_mobile) ? (item.image_desktop || []) : item.image_mobile,
                banner: item.image_banner || {},
                banner_mobile: item.image_mobile_banner || item.image_banner,
                background: item.image_background || {},
                background_mobile: item.image_mobile_background || {},
                poster: item.poster_image || item.image_poster ||  {},
            },

            use_movie_poster: (item.use_movie_poster || (item.related_movie ? "1" : "0")) || "0"
        }
    }

    _formatFeaturedContent(featuredContent) {
        return new Promise((resolve, reject)=> {
            featuredContent.image = featuredContent.featured_image ? featuredContent.featured_image.url : undefined;
            featuredContent.mobile_image = featuredContent.mobile_image ? featuredContent.mobile_image.url : featuredContent.image;
            featuredContent.logo_image = featuredContent.logo ? featuredContent.logo.image.url : undefined;
            featuredContent.button_1_url = featuredContent.section_1_button_link ? featuredContent.section_1_button_link : undefined;
            featuredContent.button_1_text  = featuredContent.section_1_button_text ? featuredContent.section_1_button_text : undefined;
            featuredContent.button_2_url = featuredContent.section_2_button_link ? featuredContent.section_2_button_link : undefined;
            featuredContent.button_2_text  = featuredContent.section_2_button_text ? featuredContent.section_2_button_text : undefined;
            let item = new FeaturedContent(featuredContent);
            // console.log("FEATURED",featuredContent,item);
            if (featuredContent.related_movie && featuredContent.related_movie.vista_movie_id) {
                MovieService.findById(featuredContent.related_movie.vista_movie_id).then((m)=> {
                    item.movie = m;
                    resolve(item);
                }, ()=>resolve(item))
            } else resolve(item);
        })
    }

    _formatCompetition(featuredContent) {
        featuredContent.image = featuredContent.image_background ? featuredContent.image_background : undefined;
        featuredContent.mobile_image = featuredContent.image_mobile_background ? featuredContent.image_mobile_background : featuredContent.image;
        featuredContent.related_movie = featuredContent.related_movie ? featuredContent.related_movie.vista_movie_id : undefined;
        return featuredContent;
    }

    _formatGeneralPage(page) {
        return {
            nid: page.nid,
            meta_description: page.meta_description,
            meta_title: page.meta_title,
            page_title: page.title,
            title: page.title,
            page_type: page.page_type,
            published: page.published,
            sections: page.sections,
            route: page.route
        }
    }

    _formatContentTypeForGeneralPage(contentItem) {
        let sectionLayout = '';
        let sectionLayoutTwo = undefined;
        let page_layout_content = this._previewSection;
        switch (this._previewSection) {
            case 'accolades':
                sectionLayout = 'accolades_block';
                break;
            case 'person':
                sectionLayout = undefined;
                if (contentItem.person_type == 'Management_Team') {
                    sectionLayoutTwo = ['person_management_team', 'person_management_team_block']
                }else{
                    sectionLayoutTwo = ['person_shareholders', 'person_shareholders_block']
                }
                break;
            case 'partners':
                sectionLayout = 'partners_block';

                break;

        }
        return PageService.getContentType(this._previewSection).then((contentItems)=> {
            // let content = [contentItems]
            let sections = [];

            if (sectionLayout)
                 sections = [
                    {
                        section_layout: sectionLayout,
                        page_content: contentItems,
                        name: null,
                        additional_button_link: null,
                        additional_button_text: null,
                        body: null,
                        body_2: null,
                        button_link: null,
                        button_text: null,
                        file_link: null,
                        file_link_2: null,
                        heading: null,
                        heading_2: null,
                        image: null,
                        mobile_image: null,
                        video_link: null
                    }
                ];

            if (sectionLayoutTwo) {
                for (var i = 0; i < sectionLayoutTwo.length; i++) {
                    var obj = sectionLayoutTwo[i];
                    sections.push({
                        section_layout: obj,
                        page_content: contentItems,
                        name: null,
                        additional_button_link: null,
                        additional_button_text: null,
                        body: null,
                        body_2: null,
                        button_link: null,
                        button_text: null,
                        file_link: null,
                        file_link_2: null,
                        heading: null,
                        heading_2: null,
                        image: null,
                        mobile_image: null,
                        video_link: null
                    })
                }

            }
            return {
                title: "Accolades",
                meta_description: 'none',
                meta_title: 'none',
                nid: contentItem.nid,
                original_item: contentItem,
                page_description: '<h2>Preview Content Type Test Page</h2>',
                page_title: 'Preview Content Type: ' + this._previewSection,
                page_type: 'General Page',
                route: `/preview-${contentItem.nid}`,
                published: false,
                sections: sections

            }
        })
    }

    _formatNews(contentItem){
        return {
            general:{
                id:contentItem.nid,
                title:contentItem.title,
                author:contentItem.author,
                date:contentItem.news_date,
                expires:contentItem.expiry_date,
                featured:contentItem.featured,
                override_link:contentItem.button_link_override,
                override_text:contentItem.button_text_override,
                related_movie:contentItem.related_movie.vista_movie_id,
                type:contentItem.news_taxonomy_type
            },
            top_section:{
                copy:contentItem.copy_section,
                summary:contentItem.copy_section.replace(/<(?:.|\n)*?>/gm, ''),
                image:contentItem.news_image ? contentItem.news_image : null,
            },
            feature_section:{
                title:contentItem.youtube_title,
                link:contentItem.news_youtube_link,
                image:contentItem.youtube_image ? contentItem.youtube_image: null,
                description:contentItem.youtube_description
            },
            bottom_section:{
                title:contentItem.section_2_title,
                copy:contentItem.bottom_copy_section,
                image:contentItem.bottom_section_image ? contentItem.bottom_section_image: null,
                image_2:contentItem.bottom_section_image_2 ? contentItem.bottom_section_image_2: null,
            },
            more_info_section:{
                title: contentItem.more_info_title,
                copy:contentItem.more_info_copy_section
            },
            title:contentItem.title,
            nid: contentItem.nid
        }
    }

    clear() {
        this._previewSection = undefined;
        this._previewContent = {};
        sessionStorage.clear()
        this.available = false;
    }

    /**
     *
     * @param section String
     * @param contentArrayToMergeWith Array
     * @returns []
     */
    addPreviewToContentArrayIfAvailable(section, contentArrayToMergeWith) {
        let content = contentArrayToMergeWith;
        if (this.hasPreviewContent(section))
            content = [this._previewContent, ...contentArrayToMergeWith];

        return content;
    }

    /**
     *
     * @param section String
     * @param contentObject Object
     */
    mergePreviewWithExistingContentIfAvailable(section, contentObject) {
        let content = contentObject;
        if (this.hasPreviewContent(section))
            Object.assign(content, this._previewContent);

        return content;
    }

    _setPreviewContent(content, original) {
        this._previewContent = content;

        if (original.cmsUrl) {
            this.cms_url = `${original.cmsUrl}/node/${original.nid}/edit`;
            sessionStorage.setItem('cms_url', this.cms_url);
        }

        sessionStorage.setItem('_previewContent', JSON.stringify(this._previewContent));
    };

    setContent(section, contentObject) {
        this.available = false;
        sessionStorage.clear();
        this._previewSection = section;
        sessionStorage.setItem('_previewSection', this._previewSection);

        if (PREVIEW_SETTINGS[section] && PREVIEW_SETTINGS[section].formatterIsPromise) {
            this.promise = this[PREVIEW_SETTINGS[section].formatter](contentObject).then((content)=> {
                this._setPreviewContent(content, contentObject);
            })

        } else {
            this._setPreviewContent((PREVIEW_SETTINGS[section] && PREVIEW_SETTINGS[section].formatter ? this[PREVIEW_SETTINGS[section].formatter](contentObject) : contentObject), contentObject);

        }
        this.available = true;

    }

    loadPimaryRoute(router) {
        if (this.promise) {
            this.promise.then(()=> {
                this.promise = undefined;
                this.loadPimaryRoute(router)
            });
            return;
        }
        if (this.hasPreviewContent() && PREVIEW_SETTINGS[this._previewSection]) {
            let route = PREVIEW_SETTINGS[this._previewSection].primary_route;
            for (var j = 0; j < Object.keys(this._previewContent).length; j++) {
                var key = Object.keys(this._previewContent)[j];
                route = route.replace(new RegExp(`:${key}`, 'g'), this._previewContent[key])
            }
            router.push(route)
        }
    }

    getPreviewConfig() {
        if (!this.hasPreviewContent()) return false;
        let section = PREVIEW_SETTINGS[this._previewSection]
        if (!section) return false;
        let routes = [];
        for (var i = 0; i < section.availableroutes.length; i++) {
            var route = section.availableroutes[i];

            // replace all route keys
            for (var j = 0; j < Object.keys(this._previewContent).length; j++) {
                var key = Object.keys(this._previewContent)[j];
                route.route = route.route.replace(new RegExp(`:${key}`, 'g'), this._previewContent[key])
            }

            if (!route.test || route.test(this._previewContent)) {
                if (route.routeReplace) {
                    route.route = route.routeReplace(this._previewContent, route.route)
                }
                routes.push(route);
            }
        }

        return {
            section: this._previewSection.replace(new RegExp("_", 'g'), ' ').replace(/\b\w/g, l => l.toUpperCase()),
            routes,
            title: this._previewContent.title,
            cms_url: this.cms_url
        }

    }

    /**
     * USED BY CONTENT.JS ONLY
     */
    getPreviewUrl() {
        return `preview-${this._previewContent.nid}`;
    }
}

export default new PreviewService();


// WEBPACK FOOTER //
// ../hasta-la-vista-middleware-api/src/service/preview-service.js